// TODO: Why isn't this on eiq/files?
export enum FileType {
  ImageSvg = 'image/svg+xml',
  ImagePng = 'image/png',
  ImageGif = 'image/gif',
  ImageJpeg = 'image/jpeg',
  VideoMp4 = 'video/mp4',
  AudioMp3 = 'audio/mpeg',
  TextCsv = 'text/csv',
  ExcelXlsx = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
}

export const ImageTypes = [FileType.ImageSvg, FileType.ImagePng, FileType.ImageGif, FileType.ImageJpeg];
export const VideoTypes = [FileType.VideoMp4];
export const AudioTypes = [FileType.AudioMp3];
export const TextTypes = [FileType.TextCsv];
